import { Injectable } from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {Zone} from '../models/zone.model';

@Injectable({
  providedIn: 'root'
})
export class ZoneService{

  private api:string = environment.api+'/propertyzones';

  constructor(private http: HttpClient) { }

  public getAllZones(){
    return this.http.get(this.api+'/findAll');
  }

  public updateZone(zone:Zone){
    return this.http.put(this.api,zone);
  }

  public deleteZone(zone:Zone){
    return this.http.delete(this.api+'/'+zone.zoneId);
  }

  public createZone(zone:Zone){
    return this.http.post(this.api,zone);
  }
}
